export default {
  marketplace: {
    sellers: {
      sellers: "Vendedores",
      addSeller: "Agregar Vendedor",
      searchBySeller: "Buscar por Nombre del Vendedor",
      noDataFound: "No se encontraron datos",
      youHaveNotAddedAnySellerYet: "Aún no has agregado ningún vendedor.",
      pleaseAddTheSellersToStart: "Por favor, agrega vendedores para comenzar",
      filter: {
        product: "Producto",
        category: "Categoría",
        countries: "Países",
        noOfProducts: "N.º de Productos",
        noOfOrders: "N.º de Pedidos",
        sellerStatus: "Estado del Vendedor",
        from: "Desde",
        to: "Hasta",
        of: "De",
        selectProduct: "Seleccionar Producto",
      },
      tableHeaders: {
        name: "Nombre",
        email: "Correo Electrónico",
        country: "País",
        noOfProducts: "N.º de Productos",
        noOfOrders: "N.º de Pedidos",
        status: "Estado",
        cityTown: "Ciudad/Pueblo",
      },
      active: "Activo",
      deactivated: "Desactivado",
      activateDeactivate: "Activar/Desactivar",
      headerTitleActivate: "Activar cuenta",
      headerTitleDeactivate: "Desactivar cuenta",
      deactivateConfirmationText: "¿Estás seguro de que deseas desactivar?",
      reasonLabel: "Razón",
      predefinedRangeLabel: "Rango Predefinido desde la Fecha Actual",
      rangeOneDay: "Un Día",
      rangeOneWeek: "Una Semana",
      rangeOneMonth: "Un Mes",
      rangeLifetime: "Toda la Vida",
      rangeCustom: "Personalizado",
      fromDateLabel: "Desde",
      toDateLabel: "Hasta",
      activationDateLabel: "Fecha de Activación:",
      deactivationReasonLabel: "Razón de desactivación:",
      activateConfirmationText: "¿Estás seguro de que deseas activar?",
      activateLabel: "Activar",
      cancelButton: "CANCELAR",
      completeButton: "Completar",
      deactivateButton: "Desactivar cuenta",
      deactivateSuccessMessage: "Cuenta desactivada con éxito",
      deactivateErrorMessage: "Error al desactivar la cuenta",
      reactivateSuccessMessage: "Cuenta reactivada con éxito",
      reactivateErrorMessage: "Error al reactivar la cuenta",
    },
    settings: {
      header: "Configuración del mercado",
      addMoreLabel: "Agregar más",
      generalSettingHeader: "Configuraciones generales",
      settingHeader: "Configuración de mi cuenta de vendedor",
      editSettingsBtn: "Editar configuración",
      numberOfProductHeading: "Configuración del número de productos",
      numberOfProduct: "Número de productos",
      storeSettingHeading: "Configuración de mi tienda",
      bankAccountHeading: "Configurar / Editar cuenta bancaria",
      editBankAccountBtn: "Gestionar cuenta bancaria",
      paypalAccountHeading: "Configurar / Editar cuenta de PayPal",
      editPaypalAccountBtn: "Gestionar cuenta de PayPal",
      pickupLocationsHeading: "Configurar / Editar ubicación de recogida",
      editPickupLocationBtn: "Gestionar ubicación de recogida",
      phoneNumberLabel: "Número de teléfono",
      defaultCurrencyLabel: "Moneda predeterminada",
      businessHoursLabel: "Horario comercial",
      notificationSettingsHeader: "Configuraciones de notificación",
      phoneNumberPlaceHolder: "Ingrese número de teléfono",
      emailPlaceHolder: "Ingrese correo electrónico",
      currencyPlaceHolder: "Seleccione moneda",
      timingLabel: "Horario",
      selectTiming: "Seleccione horario",
      bankAccounts: "Cuentas bancarias",
      phoneMobile: "Teléfono (móvil)",
      phoneHome: "Teléfono (casa)",
      cityTown: "Ciudad/Pueblo",
      addBankAccountBtn: "Agregar cuenta bancaria",
      addPaypalAccountBtn: "Agregar cuenta de PayPal",
      addPickupLocationBtn: "Agregar ubicación de recogida",
      accountTitle: "Título de cuenta",
      bankLabel: "Banco",
      typeHere: "Escriba aquí",
      paypalAccounts: "Cuentas de PayPal",
      paypalAccount: "Cuenta de PayPal",
      pickupLocations: "Ubicaciones de recogida",
      addThisAddress: "Agregar esta dirección",
      businessHours: "Horario comercial",
      timezone: "Zona horaria",
      selectTimezone: "Seleccionar zona horaria",
      businessDays: "Días hábiles",
      searchLocation: "Buscar ubicación",
    },
  },
}
